
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"-5 -5 27 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M-5-5h27v18H-5z"}}),_c('g',{attrs:{"fill":"#0038a8"}},[_c('path',{attrs:{"d":"M5-3h17v2H5zM5 1h17v2H5zM-5 5h27v2H-5zM-5 9h27v2H-5z"}})]),_c('g',{attrs:{"transform":"scale(.11)","fill":"#fcd116","stroke":"#000","stroke-width":".6","stroke-miterlimit":"20"}},[_c('g',{attrs:{"id":"c"}},[_c('g',{attrs:{"id":"b"}},[_c('g',{attrs:{"id":"a"}},[_c('path',{attrs:{"d":"M1.5 9L6 12c-8 13 1 15-6 21 3-7-3-5-3-17","stroke-linecap":"square","transform":"rotate(22.5)"}}),_c('path',{attrs:{"d":"M0 11c-2 13 4.5 17 0 22","fill":"none","transform":"rotate(22.5)"}}),_c('path',{attrs:{"d":"M0 0h6L0 33-6 0h6v33"}})]),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(45)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(90)"}})]),_c('use',{attrs:{"xlink:href":"#c","transform":"rotate(180)"}}),_c('circle',{attrs:{"r":"11"}})]),_c('g',{attrs:{"transform":"scale(.011)"}},[_c('g',{attrs:{"id":"d"}},[_c('path',{attrs:{"d":"M81-44c-7 8-11-6-36-6S16-35 12-38s21-21 29-22 31 7 40 16m-29 9c7 6 1 19-6 19S26-28 32-36"}}),_c('path',{attrs:{"d":"M19-26c1-12 11-14 27-14s23 12 29 15c-7 0-13-10-29-10s-16 0-27 10m3 2c4-6 9 6 20 6s17-3 24-8-10 12-21 12-26-6-23-10"}}),_c('path',{attrs:{"d":"M56-17c13-7 5-17 0-19 2 2 10 12 0 19M0 43c6 0 8-2 16-2s27 11 38 7c-23 9-14 3-54 3h-5m63 6c-4-7-3-5-11-16 8 6 10 9 11 16M0 67c25 0 21-5 54-19-24 3-29 11-54 11h-5m5-29c7 0 9-5 17-5s19 3 24 7c1 1-3-8-11-9S25 9 16 7c0 4 3 3 4 9 0 5-9 5-11 0 2 8-4 8-9 8"}})]),_c('use',{attrs:{"xlink:href":"#d","transform":"scale(-1 1)"}}),_c('path',{attrs:{"d":"M0 76c-5 0-18 3 0 3s5-3 0-3"}})])])
          )
        }
      }
    